import _defineProperty from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _asyncToGenerator from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import _regeneratorRuntime from "/workdir/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import React, { useCallback, useState } from "react";
import { CardCvcElement, CardExpiryElement, CardNumberElement, useElements, useStripe } from "@stripe/react-stripe-js";
import { Alert, Box, Button, IconCVV, Link, Text, TextButton } from "@catchoftheday/cg-components";
import { generateTheme } from "@catchoftheday/theme";
import { DEFAULT_ALERT_TIMEOUT } from "../../../../consts/index.js";
import { StripeInput } from "../../stripe/StripeInput/StripeInput.jsx";
import { CardCCVModal } from "../CardCCVModal/CardCCVModal.jsx"; // generateTheme with `px` values

import { jsx as ___EmotionJSX } from "@emotion/react";

var _generateTheme = generateTheme(false),
    fontSizes = _generateTheme.fontSizes,
    fontWeights = _generateTheme.fontWeights,
    colors = _generateTheme.colors;

var cardElementCommonOptions = {
  style: {
    base: {
      fontSize: fontSizes.base,
      fontWeight: fontWeights.normal
    },
    invalid: {
      color: colors.text
    }
  }
};
export var AddSavedCardForm = function AddSavedCardForm(_ref) {
  var _fieldError$cardNumbe, _fieldError$cardExpir, _fieldError$cardCvc;

  var onSubmit = _ref.onSubmit;
  var stripe = useStripe();
  var elements = useElements();

  var _useState = useState(false),
      displayCVVModal = _useState[0],
      setDisplayCVVModal = _useState[1];

  var _useState2 = useState(),
      fieldError = _useState2[0],
      setFieldError = _useState2[1];

  var _useState3 = useState(),
      globalError = _useState3[0],
      setGlobalError = _useState3[1];

  var hasFormErrors = !!(fieldError !== null && fieldError !== void 0 && fieldError.cardNumber) || !!(fieldError !== null && fieldError !== void 0 && fieldError.cardExpiry) || !!(fieldError !== null && fieldError !== void 0 && fieldError.cardCvc) || !!globalError;
  var validateCardForm = useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var cardNumberElement;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            cardNumberElement = elements === null || elements === void 0 ? void 0 : elements.getElement("cardNumber");

            if (!(!stripe || !elements || !cardNumberElement)) {
              _context.next = 3;
              break;
            }

            return _context.abrupt("return");

          case 3:
            _context.next = 5;
            return stripe.createPaymentMethod({
              type: "card",
              card: cardNumberElement
            });

          case 5:
            return _context.abrupt("return", _context.sent);

          case 6:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  })), [stripe, elements]);

  var handleFormSubmission = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(e) {
      var paymentMethod;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              e.preventDefault();
              _context2.next = 3;
              return validateCardForm();

            case 3:
              paymentMethod = _context2.sent;

              if (!(paymentMethod !== null && paymentMethod !== void 0 && paymentMethod.error)) {
                _context2.next = 7;
                break;
              }

              // We handle validation errors on a field level
              paymentMethod.error.type !== "validation_error" && setGlobalError(paymentMethod.error.message);
              return _context2.abrupt("return");

            case 7:
              onSubmit();

            case 8:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function handleFormSubmission(_x) {
      return _ref3.apply(this, arguments);
    };
  }();

  var handleStripeInputChange = function handleStripeInputChange(event) {
    var _event$error;

    var errMessage = event === null || event === void 0 ? void 0 : (_event$error = event.error) === null || _event$error === void 0 ? void 0 : _event$error.message;
    setFieldError(function (prevError) {
      return _objectSpread(_objectSpread({}, prevError), {}, _defineProperty({}, event.elementType, errMessage ? {
        message: errMessage
      } : null));
    });
  };

  return ___EmotionJSX(Box, null, globalError && ___EmotionJSX(Alert, {
    type: "inline",
    theme: "dark",
    variant: "error",
    wrapperProps: {
      mb: 6
    },
    showCloseButton: true,
    timeoutDuration: DEFAULT_ALERT_TIMEOUT,
    hideAlert: function hideAlert() {
      return setGlobalError(null);
    }
  }, globalError), ___EmotionJSX(Text, {
    mt: 0,
    fontSize: "lg"
  }, "Add credit or debit card"), ___EmotionJSX("form", {
    onSubmit: handleFormSubmission
  }, ___EmotionJSX(StripeInput, {
    label: "Card number",
    error: fieldError === null || fieldError === void 0 ? void 0 : (_fieldError$cardNumbe = fieldError.cardNumber) === null || _fieldError$cardNumbe === void 0 ? void 0 : _fieldError$cardNumbe.message
  }, ___EmotionJSX(CardNumberElement, {
    options: _objectSpread({
      showIcon: true,
      iconStyle: "solid"
    }, cardElementCommonOptions),
    onChange: handleStripeInputChange
  })), ___EmotionJSX(Box, {
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gap: 4,
    mt: 4
  }, ___EmotionJSX(Box, null, ___EmotionJSX(StripeInput, {
    label: "Expiry (MM/YY)",
    error: fieldError === null || fieldError === void 0 ? void 0 : (_fieldError$cardExpir = fieldError.cardExpiry) === null || _fieldError$cardExpir === void 0 ? void 0 : _fieldError$cardExpir.message
  }, ___EmotionJSX(CardExpiryElement, {
    options: cardElementCommonOptions,
    onChange: handleStripeInputChange
  }))), ___EmotionJSX(Box, null, ___EmotionJSX(StripeInput, {
    label: "CVC/CVV",
    display: "flex",
    justifyContent: "space-between",
    error: fieldError === null || fieldError === void 0 ? void 0 : (_fieldError$cardCvc = fieldError.cardCvc) === null || _fieldError$cardCvc === void 0 ? void 0 : _fieldError$cardCvc.message
  }, ___EmotionJSX(Box, {
    flex: 1
  }, ___EmotionJSX(CardCvcElement, {
    options: _objectSpread({
      placeholder: "123"
    }, cardElementCommonOptions),
    onChange: handleStripeInputChange
  })), ___EmotionJSX(IconCVV, null)), ___EmotionJSX(TextButton, {
    type: "button",
    onClick: function onClick() {
      return setDisplayCVVModal(true);
    },
    mt: 1,
    fontSize: "xs",
    fontWeight: "light"
  }, "What is a security code?"))), ___EmotionJSX(Button, {
    type: "submit",
    disabled: !stripe || !elements || hasFormErrors,
    mt: 6
  }, "Save Card")), ___EmotionJSX(Text, {
    my: 6
  }, "To see how we manage your personal information see our", " ", ___EmotionJSX(Link, {
    href: "/privacy"
  }, "Privacy Policy"), " and", " ", ___EmotionJSX(Link, {
    href: "/privacy"
  }, "Collection Statement")), ___EmotionJSX(CardCCVModal, {
    isOpen: displayCVVModal,
    onClose: function onClose() {
      return setDisplayCVVModal(false);
    }
  }));
};